import { DialogState, GridColumnProps, StatusChip, StatusType, Tabs } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { Layout } from '@roc/feature-app-core';
import { DataGrid, ConfirmDialog } from '@roc/ui';
import { noOpComparator } from "@roc/ui/utils";
import { IconButton, Button, makeStyles, Box, Grid } from '@material-ui/core';
import { Delete, Edit } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { createTextField } from "@roc/ui";

const useStyles = makeStyles(() => ({
  buttonsContainer: {
    padding: '0 24px',
  },
  actionHeader: {
    '& .ag-header-cell-label': {
      width: '100%',
      display: 'flex !important',
      justifyContent: 'center !important',
    }, '& .ag-header-cell-text': {
      width: '100%',
      display: 'flex !important',
      justifyContent: 'center !important',
    }
  }
}));


export const InsuranceCarrierDashboard = observer(() => {
  const { insuranceInformationStore: { insuranceCarrierStore } } = useStore();
  const { formStore } = insuranceCarrierStore;
  const classes = useStyles();

  const columns: GridColumnProps[] = [
    {
      field: 'carrierName',
      filter: 'agTextColumnFilter',
      comparator: noOpComparator,
      floatingFilter: true,
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      headerName: 'Name',
      minWidth: 150,
    },
    {
      field: 'insuranceCarrierId',
      headerName: 'Actions',
      headerClass: classes.actionHeader,
      maxWidth: 140,
      cellRenderer: 'actionCellRenderer',
      comparator: noOpComparator,
      sortable: false,
      pinned: 'right',
      lockPinned: true
    },
  ];

  useEffect(() => {
    insuranceCarrierStore.insuranceCarrierGridStore.fetchGridData();
  }, []);

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    insuranceCarrierStore.insuranceCarrierGridStore.setFilterModel(filterModel);
  };

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    insuranceCarrierStore.insuranceCarrierGridStore.setSortModel(sortModel);
  };

  const frameworkComponents = {
    actionCellRenderer: params => {
      return (
        <Grid container direction='row' justifyContent='center'>
          <Grid item>
            <IconButton
              onClick={e => {
                formStore.setDialogState(DialogState.EDIT, params.node?.data);
              }}
            >
              <Edit color='primary' />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              onClick={e => {
                formStore.setDeleteDialogState(true, params.node?.data);
              }}
            >
              <Delete color='primary' />
            </IconButton>
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <Layout maxWidth='md'>
      <DataGrid
        onFilterChanged={onFilterChanged}
        toolbar={
          <Tabs
            tabs={[{ label: 'Insurance Carriers' }]}
            onTabChange={() => { }}
            selectedTab={0}
            right={
              <Box className={classes.buttonsContainer}>
                <Button color='primary' variant='contained'
                  onClick={() => formStore.setDialogState(DialogState.ADD)}
                >Add Carrier</Button>
              </Box>
            }
          />}
        onSortChanged={onSortChanged}
        showFilters
        showPagination
        paginationData={insuranceCarrierStore.insuranceCarrierGridStore.gridData.meta}
        columns={columns}
        rows={insuranceCarrierStore.insuranceCarrierGridStore.gridData.data.rows}
        frameworkComponents={frameworkComponents} />
      <ConfirmDialog
        open={formStore.isOpen}
        confirmButtonText={'Save'}
        handleClose={() => formStore.setDialogState(null)}
        handleCancel={() => formStore.setDialogState(null)}
        handleConfirm={() => insuranceCarrierStore.saveCarrier()}
        title={formStore.isOpen &&
          `${formStore.dialogState == DialogState.ADD ? 'Add' : 'Edit'} carrier`}
        body={
          createTextField({
            store: formStore,
            label: '',
            fieldName: 'carrierName',
            testId: 'carrierName',
          })} />
      <ConfirmDialog
        open={formStore.deleteDialogState}
        confirmButtonText={'Confirm'}
        handleClose={() => formStore.setDeleteDialogState(false)}
        handleCancel={() => formStore.setDeleteDialogState(false)}
        handleConfirm={() => {
          insuranceCarrierStore.deleteCarrier();
        }}
        title={`Delete carrier`}
        body={`Are you sure you want to delete this carrier (${formStore.getValue('carrierName')})?`} />
    </Layout>
  );
});